export interface INotification {
    desc: string;
    type: ENotificationType;
    showNotify: boolean;
}

export enum ENotificationType {
    ERROR = '@ERROR',
    SUCCESS = '@SUCCESS'
}